<ifb-card>
  <mat-card appearance="raised">
    <mat-card-header class="card-header">
      <mat-card-title>
        Products
      </mat-card-title>
      <div class="arrows">
        <button mat-icon-button (click)="prevProduct()">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button mat-icon-button (click)="nextProduct()">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </mat-card-header>
    <mat-card-content class="mat-card-content-lg no-bottom-padding">
      <ifc-horizontal-list [items]="listItems"></ifc-horizontal-list>
    </mat-card-content>
  </mat-card>
</ifb-card>
